// extracted by mini-css-extract-plugin
export default {"schoolDischarge":"schoolDischarge_schoolDischarge__zP8IA","tableResponsive":"schoolDischarge_tableResponsive__XglHo"};